import { render, staticRenderFns } from "./PropertyCommunicationListTable.vue?vue&type=template&id=703b9dd4"
import script from "./PropertyCommunicationListTable.vue?vue&type=script&lang=js"
export * from "./PropertyCommunicationListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports